<div class="otp-input">
	<input
		type="text"
		inputmode="numeric"
		pattern="\\d{1}"
		#otpInput
		*ngFor="let optControl of otpArray.controls; let i = index"
		autocomplete="one-time-code"
		[formControl]="optControl"
		maxlength="1"
		[attr.data-index]="i"
		[attr.invalid]="optControl.touched && optControl.value === ''"
		[attr.valid]="optControl.value.length === 1"
		(input)="handleInput(i)"
		(keydown)="handleKeydown($event, i)"
		(paste)="handlePaste($event)" />
</div>
